/* @flow */

export default class SignDebtorApprovalRequest {
  companyId: number;
  invoiceIds: number[];
  returnSuccessUrl: string;

  constructor(companyId: number, invoiceIds: number[], returnSuccessUrl: string) {
    this.companyId = companyId;
    this.invoiceIds = invoiceIds;
    this.returnSuccessUrl = returnSuccessUrl;
  }
}
